import React, { useEffect } from 'react';
import { TemplateDemo } from '../../TemplateDemo/v2/TemplateDemo';
import { Header } from '../../Header/Header';
import { SubHeader } from '../../SubHeader/SubHeader';
import { TemplateDescription } from '../../TemplateDescription/TemplateDescription';
import { TemplateLikeThis } from '../../TemplateLikeThis/TemplateLikeThis';
import { ThankYouDialog } from '../../ThankYouDialog/ThankYouDialog';
import * as BIManager from '../../../utils/bi';
import { fedopsLogger } from '../../../utils/fedops-logger';

import s from './AppV2.scss';
import { initDealer } from '../../../utils/initDealer';
import { useTemplateContext } from '../../../context/TemplateContext/TemplateContext';
import { useConfigContext } from '../../../context/ConfigContext/ConfigContext';

interface IAppV2Props {
  dataHook?: string;
}

export const AppV2 = ({ dataHook }: IAppV2Props) => {
  const { template } = useTemplateContext();
  const { lang, dealerCmsTranslationsUrl, dealerLightboxUrl } = useConfigContext();
  const { editorSessionId, siteId, metaSiteId } = template;
  const isMobileViewPort = globalThis.innerWidth < 834;
  const ref = React.useRef<boolean>(false);

  useEffect(() => {
    BIManager.reportLoadSuccess();
    fedopsLogger.appLoaded();
  }, []);

  useEffect(() => {
    if (isMobileViewPort || ref.current) {
      return;
    }
    initDealer({
      editorSessionId,
      metaSiteId,
      siteId,
      lang,
      dealerCmsTranslationsUrl,
      dealerLightboxUrl,
    });
    ref.current = true;
  }, [dealerCmsTranslationsUrl, dealerLightboxUrl, editorSessionId, isMobileViewPort, lang, metaSiteId, siteId]);

  return (
    <div className={s.main} data-hook={dataHook}>
      <Header />
      <div className={s.container}>
        <SubHeader />
        <TemplateDemo />
        <TemplateDescription />
      </div>
      <TemplateLikeThis />
      <ThankYouDialog />
    </div>
  );
};
